import { Save, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { P, SectionTitle } from "./report-utils";

export function NotesTab({ notes, setNotes, onSave, saving }) {
    return (
        <div data-testid="section-notes">
            <SectionTitle icon={Save} title="Coach Notes" subtitle="Private observations and session planning" id="notes" />
            <div className="rounded-xl border border-slate-100 bg-white p-6 shadow-sm space-y-5">
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Private Notes</label>
                    <Textarea data-testid="coach-notes-input" value={notes.notes}
                        onChange={e => setNotes({ ...notes, notes: e.target.value })}
                        placeholder="Coaching observations, session notes, behavioral patterns noticed..."
                        rows={5} className="bg-slate-50 border-slate-200 text-sm" />
                </div>
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Next Session Plan</label>
                    <Textarea data-testid="next-session-input" value={notes.next_session_plan}
                        onChange={e => setNotes({ ...notes, next_session_plan: e.target.value })}
                        placeholder="Focus areas, exercises, topics for next session..."
                        rows={3} className="bg-slate-50 border-slate-200 text-sm" />
                </div>
                <Button data-testid="save-notes-btn" onClick={onSave} disabled={saving}
                    className="gap-2 text-sm font-semibold" style={{ background: P.navy }}>
                    {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
                    {saving ? "Saving..." : "Save Notes"}
                </Button>
            </div>
        </div>
    );
}
